import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

import ICategory from "../../categories/ICategory";
import ISubCategory from "../../categories/ISubCategory";
import { ProductListCreateButton } from "../productList/ProductListCreateButton";
import { ProductListSearch } from "../productList/ProductListSearch";
import { ProductListSearchItem } from "../productList/ProductListSearchItem";
import TabList from "../../../../yoello-lib/modules/components/UI/Tabs/TabList";
import useParseTabItems from "../useParseTabItems";
import FilterComponent, { IFiltersList } from "../../../../yoello-lib/modules/components/filterComponent/FilterComponent";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    controls: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      margin: "0 -0.5rem",

      "& .select": {
        padding: "0.5rem",
        width: "100%",

        "@media only screen and (min-width: 600px)": {
          width: "100%",
        },

        "@media only screen and (min-width: 1280px)": {
          width: "200px",
        },

        "&.has-two": {
          "@media only screen and (min-width: 600px)": {
            width: "50%",
          },

          "@media only screen and (min-width: 1280px)": {
            width: "200px",
          },
        },

        "& .MuiFormControl-root": {
          width: "100%",
        },
      },

      "& .search": {
        padding: "0.5rem",
        width: "100%",
        flexGrow: "10",

        "@media only screen and (min-width: 1280px)": {
          width: "240px",

          "& .MuiAutocomplete-root": {
            width: "240px",
            float: "right",
          },
        },
      },

      "& .filters": {
        padding: "0.5rem",
        width: "100%",

        "@media only screen and (min-width: 1280px)": {
          width: "auto",
        },
      },

      "& .create": {
        padding: "0.5rem",
        width: "100%",

        "@media only screen and (min-width: 1280px)": {
          width: "auto",
        },
      },
    },
  })
);

interface ICategoriesListControllerProps {
  setCategoryId: (catId: string) => void;
  categories: ICategory[];
  categoryID: string;
  onItemSelection: (product: ISubCategory | null) => void;
  subcategories: ISubCategory[];
  isLoading: boolean;
  venueId: string;
  filtersList: IFiltersList[],
  setFilters: (x: any) => void,
  showFilters?: boolean
}

export function CategoriesListController({
  setCategoryId,
  categories,
  categoryID,
  subcategories,
  onItemSelection,
  isLoading,
  venueId,
  filtersList,
  setFilters,
  showFilters
}: ICategoriesListControllerProps) {
  const classes = useStyles();
  const { parseCategoryItems } = useParseTabItems();
  const { categoryTabs, defaultCategoryTab } = parseCategoryItems(
    categories,
    subcategories
  );

  function getLabel(cat: ISubCategory) {
    return cat.subcategory_name;
  }
  function renderOption(cat: ISubCategory) {
    return (
      <ProductListSearchItem
        publicName={cat.subcategory_name}
        internalName={cat.subcategory_desc}
      />
    );
  }

  return (
    <div key={"menu.subcategories.title"} className={classes.controls}>
      {categoryTabs && categoryTabs.length > 0 && (
        <TabList
          level={"primary"}
          tabs={categoryTabs}
          defaultTab={defaultCategoryTab}
          onChange={setCategoryId}
          selectedTab={categoryID}
        />
      )}
      <ProductListSearch
        onItemSelection={onItemSelection}
        renderOptionFunction={renderOption}
        productList={subcategories}
        getOptionLabelFunction={getLabel}
      />
      {
        showFilters && <div className="filters" id="filters">
          <FilterComponent filtersList={filtersList} filterkey={`subcategory-filter-${venueId}`}
            setFilterState={setFilters}
          />
        </div>
      }

      <ProductListCreateButton
        title={"menu.subcategories.new"}
        buttonKey="newSubcatButton"
        onClick={() => {
          onItemSelection(null)
        }}
        isLoading={isLoading}
      />
    </div>
  );
}
